import { CirculationPermitRequest } from "./circulation-permit-request";
import { ContractCancellation } from "./contract-cancellation";
import { Invoice } from "./invoice";
import { Ip800 } from "./ip800";
import { Loan } from "./loan";
import { Order } from "./order";
import { OrderAttachment } from "./order-attachment";
import { OrderCheckList } from "./order-checklist";
import { OrderTransaction } from "./order-transation";
import { Payment } from "./payment";
import { Receipt } from "./receipt";
import { Ticket } from "./ticket";
import { Voucher } from "./voucher";

export class OrderCompleteProcess {
    order: Order;
    loans: Array<Loan>;
    attachments: Array<OrderAttachment>;
    invoices: Array<Invoice>;
    payments: Array<Payment>;
    receipts: Array<Receipt>;
    circulationPermitRequests: Array<CirculationPermitRequest>;
    customerEmailDigitalSignature: string;
    customerPhoneDigitalSignature: string;
    transactions: Array<OrderTransaction>;
    ip800Request: Ip800;
    vouchers: Array<Voucher>;
    returnReceipts: Array<Receipt>;;
    tickets: Array<Ticket>;
    orderCheckLists: Array<OrderCheckList>;
    contractCancellations: Array<ContractCancellation>;
    constructor() {
        this.order = new Order();
        this.loans = new Array<Loan>();
        this.attachments = new Array<OrderAttachment>();
        this.invoices = new Array<Invoice>();
        this.receipts = new Array<Receipt>();
        this.payments = new Array<Payment>();
        this.circulationPermitRequests = [];
        this.customerEmailDigitalSignature = "";
        this.customerPhoneDigitalSignature = "";
        this.transactions = [];
        this.ip800Request = new Ip800();
        this.vouchers = [];
        this.returnReceipts = [];
        this.tickets = [];
        this.orderCheckLists = [];
        this.contractCancellations = [];
    }
}
